import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const HigashikawaSchedule = () => {
  return (
    <section id="schedule" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-bold tracking-wider uppercase text-sm mb-2 block">Join the Journey</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">活動梯次與報名資訊</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto">
          
          {/* Schedule Cards */}
          <div className="w-full lg:w-1/2 space-y-6">
            {/* Batch 1 */}
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="border-2 border-gray-200 rounded-2xl p-6 relative overflow-hidden opacity-70 grayscale"
            >
              <div className="absolute top-4 right-4 bg-gray-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                已額滿 Full
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">第一梯次（札幌市 + 東川町）</h3>
              <div className="flex items-center gap-2 text-gray-600 mb-4">
                <SafeIcon name="Calendar" className="text-gray-400" />
                <span>時間： 2026.08.29 - 09.02</span>
              </div>
              <button disabled className="w-full py-3 bg-gray-200 text-gray-500 rounded-xl font-medium cursor-not-allowed">
                名額已滿，感謝支持
              </button>
            </motion.div>

            {/* Batch 2 */}
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="border-2 border-teal-500 rounded-2xl p-6 relative shadow-lg shadow-teal-100 bg-teal-50/30"
            >
              <div className="absolute top-4 right-4 bg-rose-500 text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse">
                開放報名中 Open
              </div>
              <div className="inline-block bg-teal-100 text-teal-800 text-xs font-bold px-2 py-1 rounded mb-3">
                加開梯次
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">第二梯次（東川町 + 美深町）</h3>
              <div className="flex items-center gap-2 text-gray-700 mb-6 font-medium text-lg">
                <SafeIcon name="Calendar" className="text-teal-600" />
                <span>時間： 2026.09.03 - 09.07</span>
              </div>
              <a 
                href="https://bit.ly/3QfuZuV" 
                target="_blank" 
                rel="noreferrer"
                className="block w-full py-4 bg-teal-600 hover:bg-teal-700 text-white text-center rounded-xl font-bold text-lg transition-colors shadow-md hover:shadow-xl"
              >
                立即填寫報名表
              </a>
            </motion.div>
          </div>

          {/* Video Section */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2 flex flex-col"
          >
            <div className="bg-gray-100 p-2 rounded-2xl flex-grow flex flex-col shadow-inner">
              <h3 className="text-center font-bold text-gray-600 py-3 flex items-center justify-center gap-2">
                <SafeIcon name="Youtube" className="text-red-500 text-xl" />
                見學介紹影片
              </h3>
              <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-black flex-grow">
                <iframe 
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/bc2JMStc4FU?si=J0KzXw-m-W2r-W8E" 
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default HigashikawaSchedule;